import React from 'react'

import { Portlet } from '_zari/core'

import MainForm from './mainForm'

import * as BloqueosPeriodosService from 'services/bloqueosPeriodo.service'

const portletBreadcrumbs = [{ name: 'Bloqueos Periodos' }]

const BloquearPeriodosMain = () => {
  const [bloqueosInfo, setBloqueosInfo] = React.useState(null)

  React.useEffect(() => {
    BloqueosPeriodosService.obtenerBloqueos().then(({ data }) => {
      setBloqueosInfo(data || {})
    })
  }, [])

  return (
    <Portlet>
      <Portlet.Header title='Bloqueos Periodos' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>{bloqueosInfo && <MainForm bloqueosInfo={bloqueosInfo} />}</Portlet.Body>
    </Portlet>
  )
}

export default React.memo(BloquearPeriodosMain)
